// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 49) return "static/chunks/49-3a3d51021a3e7661.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"146":"datadog_browser_logs","340":"layout__client_site_chrome_ui","367":"layout__minimal","748":"datadog_browser_rum"}[chunkId] || chunkId) + "." + {"146":"69c1807ed9bb04cf","205":"2e90144ef4045da8","319":"0cbc2894a3f1b950","340":"ede329fce1af1057","367":"55cb568cdf4a469d","639":"e7b660adfa99260e","748":"f8d389a1d4c7eee4"}[chunkId] + ".js";
};